import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { mapDtoPropsToCamelCase } from '@/_core/utils/mapDtos';
import { RestoreDefaultStatusesResult } from '../../../api/commands';
import { createRestoreDefaultStatusesCommand } from '../../../api/commands/factory/createStatusCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class RestoreDefaultStatuses extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'RestoreDefaultStatuses';
    public _res: RestoreDefaultStatusesResult;

    public constructor() {
        super(RestoreDefaultStatuses.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: RestoreDefaultStatuses): Promise<boolean> => {
    return await useSendCommandAsync(action, {
        createCommand: async () => await createRestoreDefaultStatusesCommand(state.id),
        onSuccess: (res: RestoreDefaultStatusesResult) => {
            action._res = res;
        }
    });
};

const reducer = (state: StorymapState, action: RestoreDefaultStatuses): void => {
    action._res.RestoredStatuses.forEach(status => {
        state.subtaskStatuses.push(mapDtoPropsToCamelCase(status));
    });
};

//@ts-ignore
registerMiddleware(RestoreDefaultStatuses.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(RestoreDefaultStatuses.ACTION_TYPE, reducer);
